// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@property --p {
  syntax: "<number>";
  inherits: true;
  initial-value: 0;
}
.nav-link {
  color: #c2c7d0 !important;
}
.pie {
  --p: 20;
  --b: 22px;
  --c: darkred;
  --w: 150px;

  width: var(--w);
  aspect-ratio: 1;
  position: relative;
  display: inline-grid;
  margin: 5px;
  place-content: center;
  font-size: 20px;
  font-weight: bold;
  font-family: sans-serif;
}

.pie:before,
.pie:after {
  content: "";
  position: absolute;
  border-radius: 50%;
}

.pie:before {
  inset: 0;
  background: radial-gradient(farthest-side, var(--c) 98%, #0000) top/var(--b)
      var(--b) no-repeat,
    conic-gradient(var(--c) calc(var(--p) * 1%), #0000 0);
  mask: radial-gradient(
    farthest-side,
    #0000 calc(99% - var(--b)),
    #000 calc(100% - var(--b))
  );
}

.pie:after {
  inset: calc(50% - var(--b) / 2);
  background: var(--c);
  transform: rotate(calc(var(--p) * 3.6deg))
    translateY(calc(50% - var(--w) / 2));
}

.animate {
  animation: p 1s 0.5s both;
}

.no-round:before {
  background-size: 0 0, auto;
}

.no-round:after {
  content: none;
}

@keyframes p {
  from {
    --p: 0;
  }
}

.col-blue {
  color: blue;
}

.col-red {
  color: rgb(215, 76, 78);
}

.col-green {
  color: rgb(40, 225, 96);
}

.col-purple {
  color: rgb(143, 41, 190);
}

@media (min-width: 767px) and (max-width: 1230px) {
  .info-box-icon {
    font-size: 20px !important;
  }

  .info-box-text {
    text-align: left !important;
    font-size: 10px !important;
  }

  .info-box-number {
    text-align: left !important;
    font-size: 10px !important;
  }

  .info-box-content {
    margin: 0px 0 0 -20px !important;
  }
}

.card-primary.card-outline {
  border-top: 3px solid #ffffff;
}

.card-abs {
  color: #1f1f1f;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 20px;
}

h3 {
  font-weight: bold !important;
}

.bg-inverse-danger {
  background-color: rgba(91, 90, 90, 0.12) !important;
  color: #000000 !important;
}

.bg-inverse-success {
  background-color: rgba(15, 183, 107, 0.12) !important;
  color: #26af48 !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

* {
  box-sizing: border-box;
}

.donut-chart {
  position: relative;
  width: 200px;
  height: 200px;
  margin: 0 auto 2rem;
  border-radius: 100%;
}

p.center {
  background: #394264;
  position: absolute;
  text-align: center;
  font-size: 28px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 130px;
  height: 130px;
  margin: auto;
  border-radius: 50%;
  line-height: 35px;
  padding: 15% 0 0;
}

.portion-block {
  border-radius: 50%;
  clip: rect(0px, 200px, 200px, 100px);
  height: 100%;
  position: absolute;
  width: 100%;
}

.circle {
  border-radius: 50%;
  clip: rect(0px, 100px, 200px, 0px);
  height: 100%;
  position: absolute;
  width: 100%;
  font-family: monospace;
  font-size: 1.5rem;
}

#part1 {
  transform: rotate(0deg);
}

#part1 .circle {
  background-color: #e64c65;
  /*transform: rotate(76deg);*/
  animation: first 1s 1 forwards;
}

#part2 {
  transform: rotate(100deg);
}

#part2 .circle {
  background-color: #11a8ab;
  animation: second 1s 1 forwards 1s;
}

#part3 {
  transform: rotate(250deg);
}

#part3 .circle {
  background-color: #4fc4f6;
  animation: third 0.5s 1 forwards 2s;
}

/* Animation */
@keyframes first {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(100deg);
  }
}

@keyframes second {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(150deg);
  }
}

@keyframes third {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(111deg);
  }
}

.bg-primaryy {
  background: #3a3939 !important;
}

.bg-dangerr {
  background: #545352 !important;
}

.bg-successs {
  background: rgb(63, 62, 62) !important;
}

.bg-warningg {
  background: rgb(57, 56, 56) !important;
}

.progress {
  border-radius: 20% !important;
}

.bg1 {
  background-color: #222121 !important;
  color: white;
}

.bg2 {
  background-color: #1c1c1fc9 !important;
  color: white;
}

.eye-icon {
  color: #000;
}

.excel-import-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.excel-import-label {
  background-color: #000;
  color: #fff;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 10px;
}

#excel-import {
  display: none;
}

.badge_leave {
  padding: 5px 8px;
  line-height: 12px;
  border: 1px solid;
  font-weight: 400;
  font-size: 13px;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  display: inline-block;
}

.col-greenn {
  color: #4caf50 !important;
  background-color: #fff;
}

.col-orange {
  color: red !important;
  background-color: #fff;
}
.col-blue {
  color: #0d6efd !important;
  background-color: #fff;
}
.rbc-event,
.rbc-day-slot .rbc-background-event {
  background-color: #000 !important;
  border-color: #fff !important;
}
.rbc-event.rbc-selected,
.rbc-day-slot .rbc-selected.rbc-background-event {
  border-color: #000 !important;
}
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.files-style {
  background-color: #1d1e1d;
  border-color: transparent;
  width: 40px;
  height: 40px;
  border-radius: 4px;
}

.file-icon {
  color: #fff !important;
  text-align: center;
}
.button-paiement {
  color: white;
  background-color: #333;
  border-radius: 4px;
  font-size: 14px;
}
.select-box-card1 {
  appearance: none;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px;
  font-size: 14px;
  color: #333;
  width: -moz-fit-content;
  width: fit-content;
}

.generate {
  background-color: #333;
  width: max-content;
  color: #fff;
  padding: 10px;
  border-radius: 10px;
  border-color: transparent;
  cursor: pointer;
  margin-bottom: 10px;
  height: auto;
}
.nav-treeview {
  overflow: hidden !important;
  max-height: 0 !important;
  transition: max-height 0.3s ease-out !important;
}
.nav-treeview.show {
  max-height: 500px !important;
  transition: max-height 0.5s ease-in !important;
}
.nav-sidebar .nav-treeview {
  display: block !important;
  list-style: none;
  padding: 0;
}
.nav-treeview.showRh {
  max-height: 1000px !important;
  transition: max-height 0.5s ease-in !important;
}
/* .nav-link {
    color: black !important;
} */
.card-primary.card-outline-tabs>.card-header a.active, .card-primary.card-outline-tabs>.card-header a.active:hover {
    border-top: 3px solid black;
}
.toggle-container {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.toggle-switch {
  width: 60px;
  height: 30px;
  background: #ccc;
  border-radius: 15px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;
}

.toggle-switch.active {
  background: #4caf50;
}

.toggle-handle {
  width: 26px;
  height: 26px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #333;
  transition: transform 0.3s;
}

.toggle-switch.active .toggle-handle {
  transform: translateX(30px);
  color: #4caf50;
}
`, "",{"version":3,"sources":["webpack://./src/utils/Css/Style.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,OAAO;EACP,SAAS;EACT,YAAY;EACZ,UAAU;;EAEV,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR;;yDAEuD;EAMvD;;;;GAIC;AACH;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB;wCACsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,MAAM;EACR;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA,cAAc;AACd;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;EAEE,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,+CAA+C;AACjD;AACA;EACE,4BAA4B;EAC5B,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,6BAA6B;EAC7B,8CAA8C;AAChD;AACA;;GAEG;AACH;IACI,2BAA2B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB","sourcesContent":["@property --p {\n  syntax: \"<number>\";\n  inherits: true;\n  initial-value: 0;\n}\n.nav-link {\n  color: #c2c7d0 !important;\n}\n.pie {\n  --p: 20;\n  --b: 22px;\n  --c: darkred;\n  --w: 150px;\n\n  width: var(--w);\n  aspect-ratio: 1;\n  position: relative;\n  display: inline-grid;\n  margin: 5px;\n  place-content: center;\n  font-size: 20px;\n  font-weight: bold;\n  font-family: sans-serif;\n}\n\n.pie:before,\n.pie:after {\n  content: \"\";\n  position: absolute;\n  border-radius: 50%;\n}\n\n.pie:before {\n  inset: 0;\n  background: radial-gradient(farthest-side, var(--c) 98%, #0000) top/var(--b)\n      var(--b) no-repeat,\n    conic-gradient(var(--c) calc(var(--p) * 1%), #0000 0);\n  -webkit-mask: radial-gradient(\n    farthest-side,\n    #0000 calc(99% - var(--b)),\n    #000 calc(100% - var(--b))\n  );\n  mask: radial-gradient(\n    farthest-side,\n    #0000 calc(99% - var(--b)),\n    #000 calc(100% - var(--b))\n  );\n}\n\n.pie:after {\n  inset: calc(50% - var(--b) / 2);\n  background: var(--c);\n  transform: rotate(calc(var(--p) * 3.6deg))\n    translateY(calc(50% - var(--w) / 2));\n}\n\n.animate {\n  animation: p 1s 0.5s both;\n}\n\n.no-round:before {\n  background-size: 0 0, auto;\n}\n\n.no-round:after {\n  content: none;\n}\n\n@keyframes p {\n  from {\n    --p: 0;\n  }\n}\n\n.col-blue {\n  color: blue;\n}\n\n.col-red {\n  color: rgb(215, 76, 78);\n}\n\n.col-green {\n  color: rgb(40, 225, 96);\n}\n\n.col-purple {\n  color: rgb(143, 41, 190);\n}\n\n@media (min-width: 767px) and (max-width: 1230px) {\n  .info-box-icon {\n    font-size: 20px !important;\n  }\n\n  .info-box-text {\n    text-align: left !important;\n    font-size: 10px !important;\n  }\n\n  .info-box-number {\n    text-align: left !important;\n    font-size: 10px !important;\n  }\n\n  .info-box-content {\n    margin: 0px 0 0 -20px !important;\n  }\n}\n\n.card-primary.card-outline {\n  border-top: 3px solid #ffffff;\n}\n\n.card-abs {\n  color: #1f1f1f;\n  font-size: 20px;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n\nh3 {\n  font-weight: bold !important;\n}\n\n.bg-inverse-danger {\n  background-color: rgba(91, 90, 90, 0.12) !important;\n  color: #000000 !important;\n}\n\n.bg-inverse-success {\n  background-color: rgba(15, 183, 107, 0.12) !important;\n  color: #26af48 !important;\n}\n\n.ms-2 {\n  margin-left: 0.5rem !important;\n}\n\n* {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.donut-chart {\n  position: relative;\n  width: 200px;\n  height: 200px;\n  margin: 0 auto 2rem;\n  border-radius: 100%;\n}\n\np.center {\n  background: #394264;\n  position: absolute;\n  text-align: center;\n  font-size: 28px;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 130px;\n  height: 130px;\n  margin: auto;\n  border-radius: 50%;\n  line-height: 35px;\n  padding: 15% 0 0;\n}\n\n.portion-block {\n  border-radius: 50%;\n  clip: rect(0px, 200px, 200px, 100px);\n  height: 100%;\n  position: absolute;\n  width: 100%;\n}\n\n.circle {\n  border-radius: 50%;\n  clip: rect(0px, 100px, 200px, 0px);\n  height: 100%;\n  position: absolute;\n  width: 100%;\n  font-family: monospace;\n  font-size: 1.5rem;\n}\n\n#part1 {\n  transform: rotate(0deg);\n}\n\n#part1 .circle {\n  background-color: #e64c65;\n  /*transform: rotate(76deg);*/\n  animation: first 1s 1 forwards;\n}\n\n#part2 {\n  transform: rotate(100deg);\n}\n\n#part2 .circle {\n  background-color: #11a8ab;\n  animation: second 1s 1 forwards 1s;\n}\n\n#part3 {\n  transform: rotate(250deg);\n}\n\n#part3 .circle {\n  background-color: #4fc4f6;\n  animation: third 0.5s 1 forwards 2s;\n}\n\n/* Animation */\n@keyframes first {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(100deg);\n  }\n}\n\n@keyframes second {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(150deg);\n  }\n}\n\n@keyframes third {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(111deg);\n  }\n}\n\n.bg-primaryy {\n  background: #3a3939 !important;\n}\n\n.bg-dangerr {\n  background: #545352 !important;\n}\n\n.bg-successs {\n  background: rgb(63, 62, 62) !important;\n}\n\n.bg-warningg {\n  background: rgb(57, 56, 56) !important;\n}\n\n.progress {\n  border-radius: 20% !important;\n}\n\n.bg1 {\n  background-color: #222121 !important;\n  color: white;\n}\n\n.bg2 {\n  background-color: #1c1c1fc9 !important;\n  color: white;\n}\n\n.eye-icon {\n  color: #000;\n}\n\n.excel-import-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.excel-import-label {\n  background-color: #000;\n  color: #fff;\n  padding: 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-bottom: 10px;\n}\n\n#excel-import {\n  display: none;\n}\n\n.badge_leave {\n  padding: 5px 8px;\n  line-height: 12px;\n  border: 1px solid;\n  font-weight: 400;\n  font-size: 13px;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.25rem;\n  display: inline-block;\n}\n\n.col-greenn {\n  color: #4caf50 !important;\n  background-color: #fff;\n}\n\n.col-orange {\n  color: red !important;\n  background-color: #fff;\n}\n.col-blue {\n  color: #0d6efd !important;\n  background-color: #fff;\n}\n.rbc-event,\n.rbc-day-slot .rbc-background-event {\n  background-color: #000 !important;\n  border-color: #fff !important;\n}\n.rbc-event.rbc-selected,\n.rbc-day-slot .rbc-selected.rbc-background-event {\n  border-color: #000 !important;\n}\n.button-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n.files-style {\n  background-color: #1d1e1d;\n  border-color: transparent;\n  width: 40px;\n  height: 40px;\n  border-radius: 4px;\n}\n\n.file-icon {\n  color: #fff !important;\n  text-align: center;\n}\n.button-paiement {\n  color: white;\n  background-color: #333;\n  border-radius: 4px;\n  font-size: 14px;\n}\n.select-box-card1 {\n  appearance: none;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 8px;\n  font-size: 14px;\n  color: #333;\n  width: fit-content;\n}\n\n.generate {\n  background-color: #333;\n  width: max-content;\n  color: #fff;\n  padding: 10px;\n  border-radius: 10px;\n  border-color: transparent;\n  cursor: pointer;\n  margin-bottom: 10px;\n  height: auto;\n}\n.nav-treeview {\n  overflow: hidden !important;\n  max-height: 0 !important;\n  transition: max-height 0.3s ease-out !important;\n}\n.nav-treeview.show {\n  max-height: 500px !important;\n  transition: max-height 0.5s ease-in !important;\n}\n.nav-sidebar .nav-treeview {\n  display: block !important;\n  list-style: none;\n  padding: 0;\n}\n.nav-treeview.showRh {\n  max-height: 1000px !important;\n  transition: max-height 0.5s ease-in !important;\n}\n/* .nav-link {\n    color: black !important;\n} */\n.card-primary.card-outline-tabs>.card-header a.active, .card-primary.card-outline-tabs>.card-header a.active:hover {\n    border-top: 3px solid black;\n}\n.toggle-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n}\n\n.toggle-switch {\n  width: 60px;\n  height: 30px;\n  background: #ccc;\n  border-radius: 15px;\n  position: relative;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.toggle-switch.active {\n  background: #4caf50;\n}\n\n.toggle-handle {\n  width: 26px;\n  height: 26px;\n  background: white;\n  border-radius: 50%;\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  color: #333;\n  transition: transform 0.3s;\n}\n\n.toggle-switch.active .toggle-handle {\n  transform: translateX(30px);\n  color: #4caf50;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
